// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2M6RA","alert":"SettungsInbox_alert__19xPO"};